import { gql } from '@soundxyz/gql-string';
import { SONG_SLOT_MAX_LENGTH } from '@soundxyz/utils/const';
import type { Maybe } from '@soundxyz/utils/helpers';
import { getCommentTimeStamp } from '@soundxyz/utils/helpers';
import type { FragmentType } from '@graphql/reactQuery';
import {
  getFragment,
  NftCommentTypeFragmentDoc,
  ReleaseCommentTypeFragmentDoc,
} from '@graphql/reactQuery';

export type CommentType = {
  id: string;
  avatarUrl: Maybe<string>;
  publicAddress: string;
  webappUri: string;
  commentText?: string;
  commentId: string | null;
  commentTimestamp?: number;
  updatedAt?: string | number;
  isEggWinner: boolean;
  isArtist: boolean;
  trackDuration?: number;
  username: string;
  ownerReleaseNftCount?: number;
};

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment NftCommentType on Nft {
    id
    serialNumber
    updatedAt
    songSlot
    isGoldenEgg
    owner {
      id
      publicAddress
      username
      webappUri
      artist {
        id
      }
      avatar {
        id
        url
      }
    }
    comment {
      id
      message
    }
  }

  fragment ReleaseCommentType on Release {
    id
    track {
      id
      duration
    }
  }
`);

export function parseCommentType({
  release: releaseFragment,
  ...nftFragment
}: { nft: FragmentType<NftCommentTypeFragmentDoc> } & {
  release: FragmentType<ReleaseCommentTypeFragmentDoc>;
}): CommentType {
  const release = getFragment(ReleaseCommentTypeFragmentDoc, releaseFragment);

  const nft = getFragment(NftCommentTypeFragmentDoc, nftFragment.nft);

  return {
    id: nft.id,
    publicAddress: nft.owner.publicAddress,
    avatarUrl: nft.owner.avatar?.url,
    updatedAt: nft.updatedAt,
    commentTimestamp:
      nft.songSlot != null
        ? getCommentTimeStamp({
            songSlot: nft.songSlot,
            totalSlots: SONG_SLOT_MAX_LENGTH,
            trackDuration: release.track.duration,
          })
        : 0,
    commentText: nft.comment?.message,
    commentId: nft.comment?.id || null,
    isArtist: !!nft.owner.artist,
    isEggWinner: nft.isGoldenEgg,
    trackDuration: release.track.duration,
    username: nft.owner.username,
    webappUri: nft.owner.webappUri,
  };
}
